import React, { FunctionComponent } from 'react';
import { SuggestOccupation, SuggestOccupationDetail } from '../../../types/personShow';

type Props = {
  title: string;
  limit: number;
  suggestOccupations: SuggestOccupation[];
  suggestOccupationDetails: SuggestOccupationDetail[];
  selectedNames: string[];
  selectedDetailIds: number[];
  onClick: (type: 'parent' | 'child', value: string | number) => void;
  handleScrollTo: (name: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  title,
  limit,
  suggestOccupations,
  suggestOccupationDetails,
  selectedNames,
  selectedDetailIds,
  onClick,
  handleScrollTo,
}) => {
  const isSelected = (list: (string | number)[], target: string | number) => list.indexOf(target) !== -1;

  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">
        {title}
        <span className="subtitle">※職種カテゴリーだけの選択も可能です</span>
        <span className="subtitle">※{limit}職種まで選択できます</span>
      </p>
      <div className="person__show__modal__inner__occupations">
        <ul className="person__show__modal__inner__location">
          {suggestOccupations.map((o) => (
            <li className="suggetsBtn" key={o.name}>
              <button
                type="button"
                onClick={() => handleScrollTo(o.name)}
                className="suggetsBtn__link"
              >
                {o.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="person__show__modal__inner__occupations--list">
        {suggestOccupationDetails.map((group) => (
          <div className="occupation--box" key={group.occupationId}>
            <p
              id={`flexbox_suggest_${group.occupationName}`}
              onClick={() => onClick('parent', group.occupationName)}
              className={`occupation--name ${isSelected(selectedNames, group.occupationName) ? 'selected' : ''}`}
            >
              {group.occupationName}
              {isSelected(selectedNames, group.occupationName) && (
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                  <path
                    d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z"
                    fill="#19190F"
                  />
                </svg>
              )}
            </p>
            {group.occupationDetails.map((od) => (
              <p
                key={od.id}
                onClick={() => onClick('child', od.id)}
                className={`flex ${isSelected(selectedDetailIds, od.id) ? 'selected' : ''}`}
              >
                {od.name}
                {isSelected(selectedDetailIds, od.id) && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                    <path
                      d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z"
                      fill="#19190F"
                    />
                  </svg>
                )}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
